import { render, staticRenderFns } from "./ActSwitch.vue?vue&type=template&id=305b0f32&scoped=true"
import script from "./ActSwitch.vue?vue&type=script&lang=js"
export * from "./ActSwitch.vue?vue&type=script&lang=js"
import style0 from "./ActSwitch.vue?vue&type=style&index=0&id=305b0f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b0f32",
  null
  
)

export default component.exports